/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, days: NonNullable<unknown> }} Bulk_Delete_Confirm_Artifacts_Description_MixedInputs */



/**
* | output |
* | --- |
* | "Delete {count} artifact(s)? Apps among them move to the trash and can be restored there for {days} days — their share links and custom domains are switched o..." |
*
* @param {Bulk_Delete_Confirm_Artifacts_Description_MixedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bulk_delete_confirm_artifacts_description_mixed = /** @type {((inputs: Bulk_Delete_Confirm_Artifacts_Description_MixedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_Delete_Confirm_Artifacts_Description_MixedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Artefakt(e) löschen? Apps darunter wandern in den Papierkorb und lassen sich dort ${i?.days} Tage lang wiederherstellen — ihre Freigabelinks und eigenen Domains werden sofort abgeschaltet und bleiben auch nach dem Wiederherstellen aus. Alles andere wird endgültig gelöscht.`)
	return /** @type {LocalizedString} */ (`Delete ${i?.count} artifact(s)? Apps among them move to the trash and can be restored there for ${i?.days} days — their share links and custom domains are switched off immediately and stay off after a restore. Everything else is deleted for good.`)
});